import PropTypes from 'prop-types';
import React from 'react';
import BackendService from '../../services/BackendService';

function Screenshot(props) {
  const { date, name } = props.match.params;
  return (
    <div>
      <img
        src={BackendService.getFullUrl(`/utils/screenshot/${date}/${name}`, {})}
        alt=""
      />
    </div>
  );
}

Screenshot.propTypes = {
  match: PropTypes.object,
};

export default Screenshot;
